class MaFacets extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.section;
    this.baseUrl = this.dataset.url || window.location.pathname;
    this.root = this.closest('.ma-shop') || this;
    this.form = this.querySelector('[data-facets-form]');
    this.timer = null;

    this.onChange = this.onChange.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onKey = this.onKey.bind(this);
    this.onPop = this.onPop.bind(this);

    this.addEventListener('change', this.onChange);
    this.addEventListener('click', this.onClick);
    this.addEventListener('submit', this.onSubmit);
    document.addEventListener('keydown', this.onKey);
    window.addEventListener('popstate', this.onPop);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKey);
    window.removeEventListener('popstate', this.onPop);
  }

  onKey(event) {
    if (event.key === 'Escape' && this.root.classList.contains('is-open')) this.close();
  }

  onPop() {
    this.render(window.location.search.replace(/^\?/, ''), false);
  }

  onChange(event) {
    const field = event.target;
    if (!field.name) return;
    if (field.type === 'number') {
      this.debounce(700);
    } else {
      this.debounce(60);
    }
  }

  onSubmit(event) {
    event.preventDefault();
    this.apply();
  }

  onClick(event) {
    const open = event.target.closest('[data-open]');
    if (open) {
      event.preventDefault();
      this.open();
      return;
    }
    if (event.target.closest('[data-close]')) {
      event.preventDefault();
      this.close();
      return;
    }
    const clear = event.target.closest('[data-clear]');
    if (clear) {
      event.preventDefault();
      this.reset();
      return;
    }
    const link = event.target.closest('[data-facet-link]');
    if (link) {
      event.preventDefault();
      const url = new URL(link.href, window.location.origin);
      this.render(url.searchParams.toString());
    }
  }

  open() {
    this.root.classList.add('is-open');
    document.documentElement.classList.add('ma-shop-locked');
    const close = this.querySelector('[data-close]');
    if (close) close.focus();
  }

  close() {
    this.root.classList.remove('is-open');
    document.documentElement.classList.remove('ma-shop-locked');
  }

  reset() {
    if (!this.form) return;
    Array.from(this.form.elements).forEach((field) => {
      if (field.type === 'checkbox') field.checked = false;
      if (field.type === 'number') field.value = '';
    });
    this.apply();
  }

  debounce(wait) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.apply(), wait);
  }

  query() {
    if (!this.form) return '';
    const data = new FormData(this.form);
    const params = new URLSearchParams();
    for (const [key, value] of data.entries()) {
      if (value === '' || value === null) continue;
      params.append(key, value);
    }
    return params.toString();
  }

  apply() {
    clearTimeout(this.timer);
    this.render(this.query());
  }

  async render(search, push) {
    const shouldPush = push !== false;
    const clean = (search || '').replace(/^\?/, '');
    const url = clean ? `${this.baseUrl}?${clean}` : this.baseUrl;
    const endpoint = clean
      ? `${this.baseUrl}?${clean}&section_id=${this.sectionId}`
      : `${this.baseUrl}?section_id=${this.sectionId}`;

    this.root.classList.add('is-busy');

    try {
      const response = await fetch(endpoint);
      const markup = await response.text();
      const parsed = new DOMParser().parseFromString(markup, 'text/html');

      ['[data-results]', '[data-bar]', '[data-filters]', '[data-apply]'].forEach((selector) => {
        const fresh = parsed.querySelector(selector);
        const current = this.querySelector(selector);
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      });

      if (shouldPush) window.history.pushState({ search: clean }, '', url);

      const top = this.getBoundingClientRect().top + window.scrollY - 120;
      if (window.scrollY > top) window.scrollTo({ top, behavior: 'smooth' });
    } catch (error) {
      window.location.href = url;
    } finally {
      this.root.classList.remove('is-busy');
    }
  }
}

if (!customElements.get('ma-facets')) customElements.define('ma-facets', MaFacets);
